<template>
    <div class="right-echarts">
        <h1>近12小时曲线
            <el-tooltip class="item" effect="dark" content="采集时间为整点时间，如12：00" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
        </h1>
        <div class="line"></div>
        <div class="use">
            <div class="tab">
                <div class="tab-title" v-for="(item, index) in arr" :key="index" :class="{ active: cur == index }"
                    @click="handleClick(item.text, index)">
                    <p>{{ item.title }}</p>
                </div>
            </div>
            <div class="select">
                <el-select v-model="value">
                    <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="echart">
            <div class="dom" id="dom1"></div>
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts";
import { formatLongToStrT } from '@/common/utils/formatTime';
import { getRequest, postRequest } from "@/common/config/realTimeRequest.js";
export default {
    data() {
        return {
            myChart: null,

            // 下拉选择框
            options: [
                {
                    value: 1,
                    label: "蒸发器侧",
                },
                {
                    value: 2,
                    label: "冷凝器侧",
                }
            ],
            value: 1,

            cur: 0,
            arr: [{
                title: "进口温度",
                text: "1",
                names: ["en_1.PV,en_5.PV,en_9.PV,en_13.PV","en_3.PV,en_7.PV,en_11.PV,en_15.PV"],
                yName: "温度(℃)",
            },
            {
                title: "出口温度",
                text: "2",
                names: ["en_2.PV,en_6.PV,en_10.PV,en_14.PV","en_4.PV,en_8.PV,en_12.PV,en_16.PV"],
                yName: "温度(℃)",
            },
            {
                title: "进口压力",
                text: "3",
                names: ["en_29.PV,en_33.PV,en_37.PV,en_41.PV","en_31.PV,en_35.PV,en_39.PV,en_43.PV"],
                yName: "压力(MPa)",
            },
            {
                title: "出口压力",
                names: ["en_30.PV,en_34.PV,en_38.PV,en_42.PV","en_32.PV,en_36.PV,en_40.PV,en_44.PV"],
                text: "4",
                yName: "压力(MPa)",
            }],
            xData: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]
        };
    },
    methods: {
        formatLongToStrT,
        handleClick(params, index) {
            this.cur = index;
            // console.log(params);
            this.handleGetData()
        },
        handleEchart() {
            // 1局部方法 echarts.init
            this.myChart = echarts.init(document.getElementById("dom1"));
            // 2 指定图表的配置项和数据 (书写配置项，设置图表的内容)
            let option = {
                grid: {
                    top: "15%",
                    left: "8%",
                    right: "7%",
                    bottom: "1%",
                    containLabel: true,
                },
                tooltip: {
                    trigger: "axis",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    borderColor: "transparent",
                    textStyle: {
                        fontSize: 12,
                        fontWeight: "400",
                        color: "#fff",
                    },
                },
                xAxis: {
                    type: "category",
                    data: this.xData,
                    name: "(h)",
                    nameTextStyle: {
                        color: "rgba(255,255,255,0.8)",
                        verticalAlign: "top",
                        lineHeight: 26,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "rgba(255,255,255,0.1)",
                        },
                    },
                    axisLabel: {
                        color: "rgba(255,255,255,0.8)",
                    },
                },
                yAxis: {
                    scale: true,
                    type: "value",
                    name: "温度(℃)",
                    nameTextStyle: {
                        color: "rgba(255,255,255,0.8)",
                        fontSize: 15,
                        lineHeight: 70,
                    },
                    nameLocation: "middle",
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "rgba(255,255,255,0.1)",
                        },
                    },

                    axisLabel: {
                        color: "rgba(255,255,255,0.8)",
                        fontSize: 14,
                    },
                    splitLine: {
                        lineStyle: {
                            color: "rgba(255,255,255,0.1)",
                            type: "dashed",
                        },
                    },
                },
                series: [
                    {
                        name: "1#机组",
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        type: "line",
                        smooth: true,
                        showSymbol: false,
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9,
                                [
                                    { offset: 0, color: "rgba(2, 99, 235, 1)" },
                                    {
                                        offset: 1,
                                        color: "rgba(2, 99, 235, 0.5)",
                                    },
                                ]
                            ),
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
                                {
                                    offset: 0,
                                    color: "rgba(2, 99, 235, 0.8)",
                                },
                                {
                                    offset: 1,
                                    color: "rgba(2, 99, 235, 0.2)",
                                },
                            ]
                            ),
                        },
                    },
                    {
                        name: "2#机组",
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        type: "line",
                        smooth: true,
                        showSymbol: false,
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
                                { offset: 0, color: "rgba(2, 99, 25, 1)" },
                                {
                                    offset: 1,
                                    color: "rgba(2, 99, 25, 0.5)",
                                },
                            ]
                            ),
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
                                {
                                    offset: 0,
                                    color: "rgba(2, 99, 25, 0.8)",
                                },
                                {
                                    offset: 1,
                                    color: "rgba(2, 99, 25, 0.2)",
                                },
                            ]
                            ),
                        },
                    },
                    {
                        name: "3#机组",
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        type: "line",
                        smooth: true,
                        showSymbol: false,
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
                                { offset: 0, color: "rgba(2, 199, 235, 1)" },
                                {
                                    offset: 1,
                                    color: "rgba(2, 199, 235, 0.5)",
                                },
                            ]
                            ),
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
                                {
                                    offset: 0,
                                    color: "rgba(2, 199, 235, 0.8)",
                                },
                                {
                                    offset: 1,
                                    color: "rgba(2, 199, 235, 0.2)",
                                },
                            ]
                            ),
                        },
                    },
                    {
                        name: "4#机组",
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                        type: "line",
                        smooth: true,
                        showSymbol: false,
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
                                { offset: 0, color: "rgba(122, 99, 235, 1)" },
                                {
                                    offset: 1,
                                    color: "rgba(122, 99, 235, 0.5)",
                                },
                            ]
                            ),
                        },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
                                {
                                    offset: 0,
                                    color: "rgba(122, 99, 235, 0.8)",
                                },
                                {
                                    offset: 1,
                                    color: "rgba(122, 99, 235, 0.2)",
                                },
                            ]
                            ),
                        },
                    },
                ],
            };
            // 3 使用刚指定的配置项和数据显示图表。（添加到div中）
            this.myChart.setOption(option);
            // 4 图表的响应式
            window.onresize = () => {
                this.myChart.resize();
            };
        },

        handleAdd() {
            setInterval(() => {
                this.cur += 1;
                if (this.cur == this.arr.length) {
                    this.cur = 0;
                }
                this.handleGetData()
            }, 60 * 1000*5)
        },

        // 获取数据
        handleGetData() {
            const now = new Date();
            // 设置分钟、秒和毫秒为 0
            now.setMinutes(0, 0, 0);
            const timestamp = now.getTime() + 1 * 60 * 60 * 1000;
            const agoTimestamp = timestamp - 12 * 60 * 60 * 1000;
            getRequest("/api/hisdata", {
                names: this.arr[this.cur].names[this.value-1],
                startTime: this.formatLongToStrT(agoTimestamp),
                endTime: this.formatLongToStrT(timestamp),
                interval: 60 * 60 * 1000,
                token: sessionStorage.getItem("realTimeToken"),
                decimal: 2,
            }).then((res) => {
                if (res.code == 0) {
                    const result = res.items[0].vals.map((item, index) => {
                        const time = item.time;
                        const fields = {};
                        // 遍历 items，将对应的 vals 赋值给动态字段
                        res.items.forEach((fieldItem) => {
                            if (fieldItem.vals[index].val=="-9999") {
                                fieldItem.vals[index].val=0
                            }
                            fields[fieldItem.name] = fieldItem.vals[index].val;
                        });
                        return { time, ...fields };
                    });
                    this.myChart.setOption({
                        xAxis: {
                            data: res.items[0].vals.map(item => item.time.slice(11, 13)),
                        },
                        series: [
                            {
                                data: result.map(item => item[this.arr[this.cur].names[this.value-1].split(",")[0]]),
                            },
                            {
                                data: result.map(item => item[this.arr[this.cur].names[this.value-1].split(",")[1]]),
                            },
                            {
                                data: result.map(item => item[this.arr[this.cur].names[this.value-1].split(",")[2]]),
                            },
                            {
                                data: result.map(item => item[this.arr[this.cur].names[this.value-1].split(",")[3]]),
                            },
                        ],
                        yAxis: {
                            name: this.arr[this.cur].yName,
                        },
                    });
                }
            })
        },

    },
    mounted() {
        this.handleEchart();
        this.handleAdd();
        this.handleGetData();
    },
    watch: {
        value(newVal) {
            console.log(newVal);
            this.handleGetData();
        }
    }
};
</script>
<style lang="less" scoped>
.right-echarts::v-deep {
    height: 260px;

    h1 {
        margin: 0px 18px 0px;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        line-height: 25px;
        text-shadow: 0px 0px 8px #005ec9;
    }

    .line {
        height: 13px;
        background-image: url(@/assets/images/cockpit/title2.png);
        background-size: contain;
        background-repeat: no-repeat;
    }

    .use {
        display: flex;
        justify-content: space-between;
        margin: 4px 0 0;

        .tab {
            display: flex;

            .tab-title {
                text-align: center;
                margin: 0 5px;
                width: 78px;
                height: 22px;
                border: 1px solid #00fff2;
                box-sizing: border-box;

                p {
                    display: inline-block;
                    width: 60px;
                    height: 22px;
                    font-size: 14px;
                    font-weight: 600;
                    color: #ffffff;
                    line-height: 22px;
                }

                &.active {
                    background: linear-gradient(122deg,
                            #0f65ea 0%,
                            #00d9ea 100%);
                    border: none;
                }
            }
        }

        .select {
            input {
                text-align: center;
                margin: 0 5px;
                width: 90px;
                height: 20px;
                box-sizing: border-box;
                background: linear-gradient(122deg, #0f65ea 0%, #00d9ea 100%);
                font-size: 14px;
                font-weight: 600;
                color: #ffffff;
                line-height: 20px;
                padding: 0 10px 0 5px;
                border-radius: 0px;
                border: none;
            }
        }
    }

    .echart {
        margin-top: 10px;
        height: 71%;

        .dom {
            height: 100%;
            user-select: none;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            position: relative;
        }
    }

    .el-input__icon {
        line-height: 20px;
    }
}
</style>